var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdscLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 29,
    viewBox: "0 0 61 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_105_7553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4608 14.5607L24.2114 8.91924C26.4883 7.585 27.2811 4.66515 25.942 2.38825C24.6078 0.111341 21.688 -0.681467 19.4111 0.657605L2.58322 10.3502L14.4608 14.5559V14.5607Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.7845 29.0101C23.4185 29.0101 25.0525 28.1689 25.9419 26.6365C27.2762 24.3596 26.4882 21.4397 24.2113 20.1055L7.38347 10.4033C5.10657 9.06902 2.18672 9.857 0.852478 12.1339C-0.48176 14.4108 0.306214 17.3307 2.58312 18.6649L19.4109 28.3671C20.1554 28.8119 20.9966 29.0101 21.7845 29.0101Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.5153 29.0101C39.3081 29.0101 40.1493 28.8119 40.8889 28.3672L57.7167 18.6649L45.989 14.3577L36.0886 20.0475C33.8117 21.3818 33.0189 24.3016 34.3579 26.5785C35.2474 28.1641 36.8814 29.0053 38.5153 29.0053V29.0101Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55.3433 19.3077C56.9772 19.3077 58.6112 18.4665 59.5007 16.9341C60.8349 14.6572 60.0469 11.7373 57.77 10.4031L40.9422 0.700867C38.6653 -0.633371 35.7454 0.154603 34.4112 2.43151C33.077 4.70841 33.8649 7.62827 36.1418 8.9625L52.9697 18.6647C53.7141 19.1095 54.5553 19.3077 55.3433 19.3077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_7553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.9488,
    height: 29.01,
    fill: "white",
    transform: "translate(0.199463)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdscLogo);
export default __webpack_public_path__ + "static/media/gdsc_logo.56929f3a0d5c0d6eba864a9f316bef3b.svg";
export { ForwardRef as ReactComponent };